import LanguageIcon from '@material-ui/icons/Language';
export const TaalIcon = LanguageIcon;

